export enum ViewMenuResultatExamenEnum {
    dossierMedical = 'dossierMedical',
    clotureDemande = 'clotureDemande',
}
